export default __webpack_public_path__ + "static/media/loading.a1a99674.gif";